import React, { useContext } from "react";
import HeadingText from "../ActionCommonComponent/HeadingText";
import InfoBox from "../../components/InfoBox";
import SignatureBox from "../../components/SignatureBox";
import PasswordField from "../../components/PasswordField";
import { AuditTrailViewContext } from "../../AuditTrailViewContext";

const RestoreBackupAction = () => {
  const { data } = useContext(AuditTrailViewContext);
  const versionContent = data?.version_content || {};

  // Extract data from version_content
  const backupName = versionContent.backup_name || "N/A";
  const backupDate = versionContent.backup_date || "N/A";
  const backupType = versionContent.backup_type || "N/A";
  const restorer =
    versionContent.restorer ||
    data?.first_name + " " + data?.last_name ||
    "N/A";
  const restoreComments = versionContent.restore_comments || "";
  const associatedVersion = data?.parent_version || "N/A";

  // Check if signature exists
  const signature = data?.signature?.data || versionContent.signature || null;

  // Check if password was entered (show placeholder if it exists in version_content)
  const hasPassword =
    versionContent.password || data?.version_content?.password;

  return (
    <>
      <HeadingText heading="Associated Version" text={associatedVersion} />
      <HeadingText heading="Details (Read Only)">
        <InfoBox
          heading="Restore a Backup"
          customeHeadWidth="30%"
          buttons={[
            { text: "Download Backup Before Restore", onClick: () => {} },
            { text: "Download Restored Backup", onClick: () => {} },
          ]}
        >
          <div className="heading-text">
            The Following Backup will be Restored:
          </div>
          <span>
            {backupName} taken on {backupDate} {backupType}
          </span>
          <br /> <br />
          <HeadingText heading="Restorer" text={restorer} normal={true} />
          <br />
          <label>Restore Backup Comments</label>
          <textarea
            className="input-textarea"
            style={{ fontFamily: `"Roboto", sans-serif` }}
            disabled
            value={restoreComments}
            rows={6}
          ></textarea>
          <br />
          <span style={{ fontSize: "15px" }}>
            <input type="checkbox" id="acknowledge" disabled checked />I
            acknowledge a Backup of the System will be saved and not deleteable
            from Backups List. The Backup File will be downloaded, and I will
            download the file to a secure location. The Audit Trail will match
            the audit trail of the backup, with an entry documenting the restore
            action, the file used for restore with checksum, and the name of the
            file downloaded and checksum.{" "}
          </span>
          <br />
          {hasPassword && <PasswordField passwordEntered={true} />}
          {signature && (
            <>
              <label style={{ marginTop: "20px" }}>Sign Here:</label>
              <SignatureBox signature={signature} />
            </>
          )}
        </InfoBox>
      </HeadingText>
    </>
  );
};

export default RestoreBackupAction;
